import { detect } from 'detect-browser';

const browser = detect();

export default browser ? browser.name : null;
